import { GenericResponseModel, LoginRequest } from "../dataModel/authModels";
import { AppyDocPostObj, DocumentRequestObj } from "../dataModel/documentModels";
import { ApiRoutes } from "./apiConfig/apiEdndpoints";
import { customAxios } from "./apiConfig/useExPressApi";

export const appointments = {
    getAppointmentList: () => {
      return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.GET_APPOINTMENT_LIST}`);
     },
}